import React from 'react'
import Navbar from '../components/Home/Navbar/Navbar'
import About from '../components/About/About'
import Journey from '../components/About/Journey'
import Footer from '../components/Home/Footer/Footer'

const Aboutpage = () => {
    return (
        <div>
        <Navbar/>
        <main>
        <About/>
        <Journey/>
        </main>
 
    
        <Footer/>
        </div>
    )
}

export default Aboutpage
